/**
 * The main api service
 */
import http from '@util/http';
import { common } from '@api/req';

export async function querySaveAccount(params) {
  return http.post(common.CUSTOM_ACCOUNT_SAVE, params);
}

export async function querySaveCustom(params) {
  return http.post(common.CUSTOM_SAVE, params);
}



// WEBPACK FOOTER //
// ./src/api/common/custom.js